import { BaseApi, HttpMethodEnum } from '../BaseApi/BaseApi';
import { ILifeEvent } from '../../entities/lifeEvents/LifeEvent.ts';

export class LifeEventsApi extends BaseApi {
    private static baseApiUrl: string = `${BaseApi.apiUrl}/LifeEvents`;

    public static apiUrls: {
        getLifeEvents: string;
        getLifeEvent: string;
        putLifeEvent: string;
        deleteLifeEvent: string;
        postLifeEvent: string;
        pdf: string;
        sendToAssistant: string;
    } = {
        getLifeEvents: `${BaseApi.apiUrl}/Patients/:id/LifeEvents`,
        getLifeEvent: `${LifeEventsApi.baseApiUrl}/:id`,
        putLifeEvent: `${LifeEventsApi.baseApiUrl}/:id`,
        deleteLifeEvent: `${LifeEventsApi.baseApiUrl}/:id`,
        postLifeEvent: LifeEventsApi.baseApiUrl,
        pdf: `${BaseApi.apiUrl}/Patients/:id/LifeEvents/pdf`,
        sendToAssistant: `${BaseApi.apiUrl}/Patients/:id/LifeEvents/SendToAssistant`,
    };

    public static async getLifeEvents(id: string): Promise<ILifeEvent[]> {
        return this.sendApiRequest<[ILifeEvent]>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.getLifeEvents,
            data: undefined,
            id: id,
        });
    }

    public static async getLifeEventById(id: string): Promise<ILifeEvent> {
        return this.sendApiRequest<ILifeEvent>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.getLifeEvent,
            data: undefined,
            id: id,
        });
    }

    public static async putLifeEvent(id: string, data: ILifeEvent): Promise<void> {
        return this.sendApiRequest<void>({
            method: HttpMethodEnum.PUT,
            path: this.apiUrls.putLifeEvent,
            data: data,
            id: id,
        });
    }

    public static async deleteLifeEvent(id: string): Promise<ILifeEvent | undefined> {
        return this.sendApiRequest<ILifeEvent>({
            method: HttpMethodEnum.DELETE,
            path: this.apiUrls.deleteLifeEvent,
            data: undefined,
            id: id,
        });
    }

    public static async postLifeEvents(data: ILifeEvent): Promise<ILifeEvent> {
        return this.sendApiRequest<ILifeEvent>({
            method: HttpMethodEnum.POST,
            path: this.apiUrls.postLifeEvent,
            data: data,
        });
    }

    public static async downloadLifeEventsPdf(patientId: string, language: string): Promise<Blob> {
        return this.sendApiRequest<Blob>({
            method: HttpMethodEnum.GET,
            path: `${this.apiUrls.pdf}?language=${language}`,
            data: undefined,
            id: patientId,
            extraOptionsConfig: { responseType: 'blob' },
        });
    }

    public static async sendLifeEventsToAssistant(
        patientId: string,
        language: string,
    ): Promise<{ assistantName: string; assistantEmail: string }> {
        return this.sendApiRequest<{ assistantName: string; assistantEmail: string }>({
            method: HttpMethodEnum.POST,
            path: `${this.apiUrls.sendToAssistant}?language=${language}`,
            data: undefined,
            id: patientId,
        });
    }

    public static downloadPdfFile(pdfBlob: Blob, filename?: string): void {
        const url = window.URL.createObjectURL(pdfBlob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename || `LifeEvents_${new Date().toISOString().split('T')[0]}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    }
}
